import { render, staticRenderFns } from "./NormalAddonModal.vue?vue&type=template&id=1a823118&scoped=true&"
import script from "./NormalAddonModal.vue?vue&type=script&lang=js&"
export * from "./NormalAddonModal.vue?vue&type=script&lang=js&"
import style0 from "./NormalAddonModal.vue?vue&type=style&index=0&id=1a823118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a823118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a823118')) {
      api.createRecord('1a823118', component.options)
    } else {
      api.reload('1a823118', component.options)
    }
    module.hot.accept("./NormalAddonModal.vue?vue&type=template&id=1a823118&scoped=true&", function () {
      api.rerender('1a823118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/AddonModal/NormalAddonModal.vue"
export default component.exports